import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { environment } from '../../../../environments/environment'
import { DepartmentModel } from '../../../core/models/department.model'

@Injectable({
  providedIn: 'root',
})
export class DepartmentService {
  private http = inject(HttpClient)
  private planifyApiUrl = environment.planifyApiUrl
  public route = 'departments'

  constructor() {}

  public getAll() {
    return this.http.get<DepartmentModel[]>(
      `${this.planifyApiUrl}/${this.route}`
    )
  }
}
